import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface SectionCardProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  noPadding?: boolean;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

export const SectionCard: React.FC<SectionCardProps> = ({ title, description, action, noPadding, sx, children }) => (
  <Card
    sx={[
      { border: '1px solid', borderColor: 'divider', boxShadow: 'none', borderRadius: 2 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {(title || description || action) && (
      <Box
        sx={{
          px: 2.5,
          py: 1.75,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box>
          <Typography variant='subtitle2' fontWeight={600}>
            {title}
          </Typography>
          {description && (
            <Typography variant='body2' color='text.secondary' sx={{ mt: 0.25 }}>
              {description}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
    )}
    <Box sx={noPadding ? {} : { p: 2.5 }}>{children}</Box>
  </Card>
);
